import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function getKnowledgeCategory() {
    return dispatch => {
    return axios.get(API_URL+"/api/knowledgeCategory")
}
}

export function getIntentsByKnowledgeCategory({knowledgeCategoryId}) {
    return dispatch => {
    return axios.post(API_URL+"/api/intents/listByKnowledge",{knowledgeCategoryId})
}
}

export function getIntents() {
    return dispatch => {
    return axios.get(API_URL+"/api/intents")
}
}

export function getIntentById({intentId}) {
    return dispatch => {
    return axios.post(API_URL+"/api/intents",{_id: intentId})
}
}

export function getbotSettings() {
    return dispatch => {
    return axios.get(API_URL+"/api/bot")
}
}